import type { Tag } from '#domains/tags';
import type { SearchQuery, SearchToken } from '../types';
import { EmptySearchQuery, Filters, Sources } from '../types';

export const prepareSearchQuery = (
  tokens: SearchToken[],
  allTags: Tag[]
): SearchQuery => {
  if (!tokens) return EmptySearchQuery;

  let q = tokens
    .filter(token => token.type === 'text')
    .map(token => token.value)
    .join(' ');

  const sources = tokens
    .filter(token => token.type === 'source')
    .filter(token => {
      if (Sources.includes(token.value)) {
        return true;
      }

      q = `${q} ${token.value}`.trim();

      return false;
    })
    .map(token => token.value);

  const filters = tokens
    .filter(token => token.type === 'filter')
    .filter(token => {
      if (Filters.includes(token.value)) {
        return true;
      }

      q = `${q} ${token.value}`.trim();

      return false;
    })
    .map(token => token.value);

  const tagIds = tokens
    .filter(token => token.type === 'tag')
    .map(token => {
      if (token.id) return token.id;

      const tag = allTags.find(t => t.fullName === token.fullName);

      if (tag) {
        return tag.id;
      }

      q = `${q} ${token.fullName.replace(/[^\w\s]/g, ' ')}`.trim();

      return undefined;
    })
    .filter(val => val !== undefined);

  return { q, sources, filters, tagIds };
};
